/** Helpers for guest chat conversation-blocked / unblocked system messages. */

import { isSystemMessage } from "./verificationMessages";

export const isConversationBlockedMessage = (msg) =>
  isSystemMessage(msg) &&
  /conversation\s+(has\s+been\s+)?blocked/i.test(String(msg?.text || ""));

export const isConversationUnblockedMessage = (msg) =>
  isSystemMessage(msg) && /conversation\s+unblocked/i.test(String(msg?.text || ""));

/**
 * The block/unblock state can toggle over time, so look for whichever of
 * the two system messages is most recent — matches the pattern used for
 * session-transfer/verification banners.
 */
export const getBlockedBannerState = (messages = []) => {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const msg = messages[i];
    if (isConversationUnblockedMessage(msg)) return null;
    if (isConversationBlockedMessage(msg)) return { type: "blocked" };
  }
  return null;
};
